
import createIcon from "./createIcon";

export const MapPinIcon = createIcon('MapPin', (props) => {
  return (
    <svg {...props}>
      <g>
        <g>
          <path d="M14,6.8541259765625C14,11.9166259765625,8.75,15.6666259765625,8,15.6666259765625C7.25,15.6666259765625,2,11.9166259765625,2,6.8541259765625C2,3.4368659765625,4.68629,0.6666259765625,8,0.6666259765625C11.31371,0.6666259765625,14,3.4368659765625,14,6.8541259765625ZM12.5,6.8541259765625Q12.5,4.8990259765625,11.16579,3.5231259765625Q9.8504,2.1666259765625,8,2.1666259765625Q6.1496,2.1666259765625,4.834210000000001,3.5231259765625Q3.5,4.8990259765625,3.5,6.8541259765625Q3.5,9.5494059765625,5.836180000000001,12.1581259765625Q6.69184,13.1136259765625,7.62302,13.7846259765625Q7.82856,13.9327259765625,8,14.0389259765625Q8.17144,13.9327259765625,8.37698,13.7846259765625Q9.30816,13.1136259765625,10.16382,12.1581259765625Q12.5,9.5494059765625,12.5,6.8541259765625Z" fillRule="evenodd" fill={props.color} fillOpacity="1" />
        </g>
        <g>
          <ellipse cx="8" cy="6.6666259765625" rx="1.5" ry="1.5" fill={props.color} fillOpacity="1" />
        </g>
      </g>
    </svg >
  )
});
